import type { IconSizes } from '@frameio/vapor-icons';
import { IconArchive, IconLock, IconProject } from '@frameio/vapor-icons';
import { theme } from '@frameio/vapor-theme';

type ProjectIconProps = {
  isInactiveProject: boolean;
  isRestrictedProject: boolean;
  size?: IconSizes;
};

export const ProjectIcon = ({
  isInactiveProject,
  isRestrictedProject,
  size = 16,
}: ProjectIconProps) => {
  const iconProps = {
    color: theme.colors.icon.primary,
    size,
  };

  if (isInactiveProject) return <IconArchive {...iconProps} />;
  if (isRestrictedProject) return <IconLock {...iconProps} />;
  return <IconProject {...iconProps} />;
};
